/* eslint-disable no-unused-vars */
import {
  useToast,
  useDisclosure,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  Modal,
  ModalFooter,
  Image,
} from "@chakra-ui/react";
import React, { useContext, useEffect, useRef, useState } from "react";
import { CanvasContext } from "../../Components/core/workspace/CanvasContext";
import "../../Styles/Canvas.css";
import "./panel.css";
import ClickMenuList from "./ClickMenuList";
import InvitationBG from "../../assets/InvitationBg.png";
import nextButton from "../../assets/NextButton.png";
import saveIcon from "../../assets/canva/SaveIcon.svg";
import axios from "axios";
import { Link, useParams } from "react-router-dom";
import TryPlus from "../../assets/TryPlus.png";
import EarnCoins from "../../assets/Earn coins.png";
import Shorcuts from "../../assets/ShortCuts (1).png";
import BackDrop from "../CanvasPages/BackDrop";
import { BASE_URL_MEDIA, BASE_URL_TEMPLATE } from "../../Redux/App/action";
import { helpData } from "../../Constants";
import { TiEye } from "react-icons/ti";

const Panel = () => {
  const [webview, setWebview] = useState(false);
  const [component, setComponent] = useState(<BackDrop />);
  const { canvas, canvasRef } = useContext(CanvasContext);
  const [fontChanger, setFontChanger] = useState(false);
  const [showShortcut, setshowShortcut] = useState(false);
  const { isOpenn, onOpenn, onClosee } = useDisclosure();
  const [showCoins, setshowCoins] = useState(false);
  const boxRef = useRef(null);
  const showedImage = localStorage.getItem("imagePreview");
  const accessToken = localStorage.getItem("token");
  const toast = useToast();
  const params = useParams();
  const id = params._id;
  const apptoken = params._token;
  const appeventid = params._eventid;
  const tempId = localStorage.getItem("template");
  const [boxHeight, setBoxHeight] = useState(null);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [bigShow, setBigShow] = useState(null);
  const initialRef = React.useRef(null);
  const finalRef = React.useRef(null);
  const [downloadFormat, setDownloadFormat] = useState("");
  const [temp, setTemp] = useState([]);
  const [tempFont, setTempFont] = useState([]);
  const [jsonData, setJsonData] = useState([]);
  const [sentData, setSentData] = useState([]);
  const [previewRes, setPreviewRes] = useState("");
  const [width] = useState(365);
  const [height] = useState(490);
  const [downloadPreview, setDownloadPreview] = useState("");
  const Tid = localStorage.getItem("templateId");

  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const [isUploadModalOpen, setUploadModalOpen] = useState(false);
  const [isPreviewModalOpen, setPreviewModalOpen] = useState(false);
  const userImageFromLocal = localStorage.getItem("userImage");
  const [showShortcutsModal, setShowShortcutsModal] = useState(false);

  // const sysType = navigator.userAgent.includes("Linux");
  // const osType = navigator.userAgent.includes("Andriod");
  // alert(navigator.userAgentData.platform);
  localStorage.setItem("user", true);

  const OverlayOne = () => (
    <ModalOverlay bg="blackAlpha.300" backdropFilter="blur(10px)" />
  );

  const OverlayTwo = () => (
    <ModalOverlay bg="blackAlpha.300" backdropFilter="blur(10px)" />
  );

  const [overlay, setOverlay] = React.useState(<OverlayOne />);

  const openShortcutsModal = () => {
    setShowShortcutsModal(true);
  };

  const closeShortcutsModal = () => {
    setShowShortcutsModal(false);
  };

  useEffect(() => {
    if (!localStorage.getItem("hasReloaded")) {
      localStorage.setItem("hasReloaded", "true");
      window.location.reload();
    } else {
      localStorage.removeItem("hasReloaded");
    }
  }, []);

  const eventId = localStorage.getItem("eventId");

  const preloadImagesFromJson = (json, callback) => {
    const parsedJson = JSON.parse(json);
    const imageObjects = parsedJson.objects.filter(
      (obj) => obj.type === "image",
    );
    let loadedCount = 0;

    if (imageObjects.length === 0) {
      callback(); // No images to preload, so proceed immediately.
      return;
    }

    imageObjects.forEach((imgObj) => {
      if (imgObj.type === "image") {
        const imgElement = new window.Image();
        imgElement.crossOrigin = "anonymous";
        imgElement.onload = () => {
          loadedCount++;
          if (loadedCount === imageObjects.length) {
            callback(); // All images preloaded
          }
        };
        imgElement.onerror = () => {
          console.error("Error preloading image:", imgObj.src);
        };
        imgElement.src = imgObj.src;
      }
    });
  };

  const hostname = window.location.hostname;

  useEffect(() => {
    const getTemplate = async () => {
      try {
        const response = await axios.get(
          `${BASE_URL_TEMPLATE}/template-builder/by-source-media-id?sourceMediaId=${id}`,
        );

        if (response.status === 200) {
          let modifiedData = response.data.payload.data;

          switch (hostname) {
            case "wishfy.io":
              modifiedData = modifiedData.replaceAll(
                "api.wishfy.io",
                "wishfy.io",
              );
              modifiedData = modifiedData.replaceAll(
                "ik.imagekit.io/bxndingik",
                "wishfy.io",
              );
              modifiedData = modifiedData.replaceAll(
                "images.wishfy.io",
                "wishfy.io",
              );
              modifiedData = modifiedData.replaceAll(
                "dev.api.wishfy.io",
                "wishfy-web-dev.wishfy.io",
              );
              break;
            case "wishfy-web.wishfy.io":
              modifiedData = modifiedData.replaceAll(
                "api.wishfy.io",
                "wishfy-web.wishfy.io",
              );
              modifiedData = modifiedData.replaceAll(
                "ik.imagekit.io/bxndingik",
                "wishfy-web.wishfy.io",
              );
              modifiedData = modifiedData.replaceAll(
                "images.wishfy.io",
                "wishfy-web.wishfy.io",
              );
              break;
            case "wishfy-web-dev.wishfy.io":
              modifiedData = modifiedData.replaceAll(
                "ik.imagekit.io/bxndingik/dev",
                "wishfy-web-dev.wishfy.io",
              );
              modifiedData = modifiedData.replaceAll(
                "dev.api.wishfy.io",
                "wishfy-web-dev.wishfy.io",
              );
              modifiedData = modifiedData.replaceAll(
                "images.wishfy.io",
                "wishfy-web-dev.wishfy.io",
              );
              break;
            case "localhost":
              modifiedData = modifiedData.replaceAll(
                "ik.imagekit.io/bxndingik/dev",
                "wishfy-web-dev.wishfy.io",
              );
              modifiedData = modifiedData.replaceAll(
                "ik.imagekit.io/bxndingik",
                "wishfy.io",
              );
              modifiedData = modifiedData.replaceAll(
                "dev.api.wishfy.io",
                "wishfy-web-dev.wishfy.io",
              );
              modifiedData = modifiedData.replaceAll(
                "images.wishfy.io",
                "wishfy-web-dev.wishfy.io",
              );
              break;
            default:
              modifiedData = modifiedData.replaceAll(
                "ik.imagekit.io/bxndingik/dev",
                "wishfy-web-dev.wishfy.io",
              );
              modifiedData = modifiedData.replaceAll(
                "dev.api.wishfy.io",
                "wishfy-web-dev.wishfy.io",
              );

              break;
          }

          setTemp(modifiedData);

          // Extract fonts from templateData
          const fonts = extractFonts(modifiedData);
          localStorage.setItem("templateId", response.data.payload.templateId);
        }
      } catch (error) {
        console.log(error);
      }
    };

    // Function to extract fonts from templateData
    const extractFonts = (templateData) => {
      const fonts = [];

      if (templateData && templateData.objects) {
        templateData.objects.forEach((object) => {
          if (object.type === "textbox" && object.fontFamily) {
            fonts.push(object.fontFamily);
          }
        });
      }

      return fonts;
    };

    getTemplate();
  }, [id]);

  // const loadFonts = async (templateData) => {
  //   const objects = templateData.objects;
  //   const fontPromises = [];

  //   for (let i = 0; i < objects.length; i++) {
  //     const object = objects[i];
  //     if (object.type === "textbox" && object.fontFamily) {
  //       const fontName = `customFont${i}`;
  //       fontPromises.push(loadFont(fontName, object.fontFamily));
  //     }
  //   }

  //   try {
  //     // Wait for all fonts to load
  //     await Promise.all(fontPromises);
  //   } catch (error) {
  //     console.error("Error loading fonts:", error);
  //   }
  // };

  // Function to load a font
  // const loadFont = async (fontName, fontFamily) => {
  //   try {
  //     const fontFace = new FontFace(fontName, `url(${fontFamily})`);
  //     await fontFace.load();
  //     document.fonts.add(fontFace);
  //     console.log(`Font loaded: ${fontName} from URL: ${fontFamily}`);
  //   } catch (error) {
  //     console.error("Error loading font:", error);
  //   }
  // };

  // useEffect(() => {
  //   if (!localStorage.getItem("hasReloaded")) {
  //     localStorage.setItem("hasReloaded", "true");
  //     window.location.reload();
  //   } else {
  //     localStorage.removeItem("hasReloaded");
  //   }
  // }, []);

  // Function to load fonts from the template data

  useEffect(() => {
    if (canvas == null || temp.length === 0) {
      return;
    }
    const loadFont = (fontUrl, fontName) => {
      const newStyle = document.createElement("style");
      newStyle.appendChild(
        document.createTextNode(`
        @font-face {
          font-family: ${fontName};
          src: url(${fontUrl}) format('truetype');
        }
      `),
      );
      document.head.appendChild(newStyle);
    };

    preloadImagesFromJson(temp, () => {
      // All images in the JSON have been preloaded with the correct crossOrigin setting
      canvas.loadFromJSON(temp, () => {
        let index = 1;
        canvas.forEachObject((obj) => {
          if (obj.type === "textbox") {
            const fontUrl = obj.get("fontFamily");
            const fontName = `DynamicFont${index++}`;
            loadFont(fontUrl, fontName);
            obj.set("fontFamily", fontName);
          }
        });
        canvas.renderAll();
      });
    });
    // canvas.loadFromJSON(temp, () => {
    //   let index =1;
    //   canvas.forEachObject((obj) => {
    //     if (obj.type === 'textbox') {
    //       const fontUrl = obj.get('fontFamily');
    //       const fontName = `DynamicFont${index++}`;
    //       loadFont(fontUrl, fontName);
    //       obj.set('fontFamily', fontName);
    //     }
    //   });
    //   canvas.renderAll();
    // });
    //canvas.loadFromJSON(temp);
    //canvas.renderAll();
    //canvas.setHeight(490);
  }, [canvas, temp]); // useEffect dependency array

  const handleSubmit = (data) => {
    const requestData = {
      templateId: Tid,
      data: JSON.stringify(data),
      sourceMediaId: id,
      canvasHeight: height,
      canvasWidth: width,
      shareType: "SAVE_N_SHARE",
    };
    axios
      .post(
        `${BASE_URL_TEMPLATE}/template-builder/create/user/template`,
        requestData,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken}`,
          },
        },
      )
      .then((response) => {
        setSentData(response.data);
        // localStorage.setItem("previewId", response.data.payload.id);
        // localStorage.removeItem("source");
        // localStorage.removeItem("templateId");
      })
      .catch((error) => {
        console.log(`${error.message}`);
        console.error(error);
      });
  };
  const preview = localStorage.getItem("previewId");
  const handlePreview = () => {
    let dt = canvas.toDataURL();
    setPreviewRes(dt);

    const apiUrl = `${BASE_URL_MEDIA}/media/file/admin/base64-to-image`;

    const requestData = {
      base64: dt.replace("data:image/png;base64,", ""),
      fileType: "png",
      mediaType: "IMAGE",
    };

    const config = {
      headers: {
        accept: "*/*",
        "Content-Type": "application/json",
      },
    };

    axios
      .post(apiUrl, requestData, config)
      .then((response) => {
        localStorage.setItem("InvitationPreview", response.data);
      })
      .catch((error) => {
        console.error("API error:", error);
      });
  };

  const handleSendServer = () => {
    let dt = canvas.toDataURL();
    // setJsonData(data);
    // handleSubmit(data);
    localStorage.removeItem("eventId");

    toast({
      title: "Invitation Saved! Click Preview",
      status: "success",
      duration: 3000,
      position: "top",
      isClosable: true,
    });
  };

  window.onload = function () {
    var button = document.getElementById("justForWebViewKeyboard");
    button.click();
    console.log(webview);
  };

  return (
    <>
      {/* heading */}
      <h1
        id="justForWebViewKeyboard"
        className="text-2xl sm:text-3xl font-bold flex justify-center sm:justify-start pt-4 sm:pt-10 fontfamily-oswald"
        style={{ fontFamily: "Oswald, sans-serif" }}
      >
        {webview ? " " : "CUSTOMIZE CARD"}
      </h1>

      <div
        style={{
          background: `url(${InvitationBG}) no-repeat center`,
          backgroundSize: "100% 100%", // This will make the image cover the entire width
        }}
        className="md:mx-10 md:my-4"
      >
        {/* content */}
        <div className="flex flex-col gap-8 sm:gap-16 md:flex-row justify-between p-2 sm:p-10 items-center flex-wrap">
          {/* Edit content */}
          <div className="flex-1 order-2 w-full sm:w-[80%] md:w-1/3 justify-center items-center md:order-1">
            <div className="flex justify-center items-center gap-14 mb-11">
              <div onClick={handleSendServer} className="cursor-pointer">
                <div className="rounded-full cursor-pointer bg-green-500 p-6">
                  <img src={saveIcon} alt="save-icon" loading="lazy" />
                </div>
                <button className="font-semibold mt-2 text-[#3d3d3d]">
                  Save
                </button>
              </div>
              <div
                onClick={() => {
                  handlePreview();
                  setOverlay(<OverlayTwo />);
                  setPreviewModalOpen(true);
                  onOpen();
                }}
                className="cursor-pointer"
              >
                <div className="rounded-full cursor-pointer bg-blue-500 p-6">
                  <TiEye className="text-white text-xl" />
                </div>
                <button className="font-semibold mt-2 text-[#3d3d3d]">
                  Preview
                </button>
              </div>
            </div>
            <Modal
              isCentered
              isOpen={isPreviewModalOpen}
              onClose={() => setPreviewModalOpen(false)}
              size={{ base: "md", md: "xl" }}
            >
              {overlay}
              <ModalContent>
                <ModalHeader fontSize={{ base: "12px", md: "18px" }}>
                  Your Invitation Preview
                </ModalHeader>
                <ModalCloseButton size={{ base: "sm", md: "lg" }} />
                <ModalBody>
                  <Image margin={"auto"} h="400px" src={previewRes} />
                </ModalBody>
                <ModalFooter></ModalFooter>
              </ModalContent>
            </Modal>

            {/* upload and replace file */}
            {component}
          </div>
          {/* Canvas Content */}
          <div className="flex-1 order-1 w-full h-full flex justify-center items-center md:block md:order-2">
            <canvas width={"100%"} height={"100%"} ref={canvasRef}></canvas>
            <ClickMenuList />
          </div>
          {/* Other Help */}
          <div className="flex-1 flex flex-col gap-3 order-3">
            <Link
              to={
                appeventid ? `/NextRsvp/${id}/${appeventid}` : `/NextRsvp/${id}`
              }
              className="flex justify-center"
            >
              <img
                src={nextButton}
                alt="Next"
                style={{
                  width: "200px",
                  maxWidth: "100px",
                  cursor: "pointer",
                }}
              />
            </Link>
            <div className="w-full flex justify-center">
              <button className="bg-[#E2E8F0] text-[#3d3d3d] rounded-3xl p-2 flex justify-between items-center w-full">
                <img src={TryPlus} className="h-5 md:h-7" alt="Try Plus" />
                <div className="">Try Plus</div>
                <div className="mr-[30px]"></div>
              </button>
            </div>

            <div className="w-full flex justify-center">
              <button className="bg-[#E2E8F0] text-[#3d3d3d] rounded-3xl p-2 flex justify-between items-center w-full">
                <img
                  src={EarnCoins}
                  className="h-5 md:h-7 mr-2"
                  alt="Earn 5 Coins Per Invite"
                />
                <div>Earn 5 Coins Per Invite </div>
                <div className="mr-[30px]"></div>
              </button>
            </div>

            <div className="w-full flex justify-center">
              <button
                className="bg-[#E2E8F0] text-[#3d3d3d] rounded-3xl p-2 flex justify-between items-center w-full"
                onClick={openShortcutsModal}
              >
                <img src={Shorcuts} className="h-5 md:h-7 mr-2" alt="Help" />
                <div>Help</div>
                <div className="mr-[30px]"></div>
              </button>
              <Modal
                isCentered
                isOpen={showShortcutsModal} // Show the modal when `showShortcutsModal` is true
                onClose={closeShortcutsModal} // Call the closeShortcutsModal function to close the modal
                size={{ base: "md", md: "xl" }}
              >
                <ModalOverlay bg="blackAlpha.300" backdropFilter="blur(10px)" />
                <ModalContent>
                  <ModalHeader fontSize={{ base: "12px", md: "18px" }}>
                    Help
                  </ModalHeader>
                  <ModalCloseButton size={{ base: "sm", md: "lg" }} />
                  <ModalBody>
                    <h2 className="mb-6">
                      Here's a concise guide for customizing a card template:
                    </h2>
                    {helpData.map((data) => {
                      return (
                        <div key={data._id}>
                          <div className="mb-8">
                            <span className="font-bold">{`${data?._id}. ${data?.title}`}</span>{" "}
                            {data?.description}
                          </div>
                        </div>
                      );
                    })}
                  </ModalBody>
                  <ModalFooter></ModalFooter>
                </ModalContent>
              </Modal>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Panel;
